import Root from './Root.vue'
import home from './home'
import categories from './categories'
import view from './view'
import first from './first'
export default [
    {
        path: '/gospel',
        component: Root,
        children: [
            ...home,
            ...categories,
            ...view,
            ...first,
        ]
    },
]
